const importAll = context => {
  const modules = {};
  for (const key of context.keys()) {
    const match = key.match(/^\.\/([a-zA-Z0-9_-]+).js$/);
    if (match) {
      const name = match[1];
      if (name !== "index") {
        modules[name] = context(key);
      }
    }
  }
  return modules;
};
const webPackContext = require.context("./", false, /^\.\/([a-zA-Z0-9_-]+).js$/);
const modules = importAll(webPackContext);

export default modules;



// WEBPACK FOOTER //
// ./lib/masterData/schemas/index.js